module.exports = __webpack_public_path__ + "img/img.25707b58.png";